import React, { Fragment, useState } from "react";
import { RiArrowRightSLine } from "react-icons/ri";
import Timeline from "../components/Timeline";
import { npsSubmitApi } from "../utils/api";
import { format } from "date-fns";
// import { useJitsu } from "@jitsu/react";

const deliveryStatuses = [
  {
    id: 4,
    status: "Order shipped",
  },
  {
    id: 3,
    status: "In transit",
  },
  {
    id: 2,
    status: "Out for delivery",
  },
  {
    id: 1,
    status: "Delivered",
  },
];

function OrderDetailsPage({ orderDetails, settings }) {
  const OrderDetailsBox = ({ shipment, index }) => {
    const [openScans, setOpenScans] = useState(false);
    // const { track } = useJitsu();
    const TimelineItem = ({ item, status }) => (
      <div className="relative pl-5 pb-4 last:pb-0">
        <span
          className={`absolute -left-1.5 top-1 w-3 h-3 rounded-full border border-[#16AC37] ${
            status ? "bg-[#16AC37]" : "bg-white"
          }`}
        ></span>
        <p className="text-xs text-[#424A59]">{item.status || item.label}</p>
        {(item.time || item.date) && (
          <p className="text-[11px] text-[#6F7580]">{item.time || item.date}</p>
        )}
      </div>
    );

    return (
      <div className="p-5 bg-white rounded-xl mt-4">
        <div className="flex items-center w-full">
          <p className="text-sm">Shipment {index}</p>
          {shipment.current_status_desc !== "Order Placed" && (
            <button
              className="ml-auto flex items-center text-white pl-3 pr-2 py-1 text-[10px] rounded"
              style={{
                background: settings["--site-widget-primary-color"],
              }}
              onClick={() => {
                setOpenScans(true);
                // track("clicked_on_order_details");
              }}
            >
              View Details <RiArrowRightSLine className="text-lg font-bold" />
            </button>
          )}
        </div>

        {shipment.current_status_desc && (
          <p
            className="mt-2 inline-block text-xs px-2 py-1 rounded"
            style={{
              color:
                shipment.current_status_desc
                  .toLowerCase()
                  .includes("delivered") &&
                !shipment.current_status_desc.toLowerCase().includes("rto")
                  ? "#16AC37"
                  : settings["--site-widget-primary-color"],
              background:
                shipment.current_status_desc
                  .toLowerCase()
                  .includes("delivered") &&
                !shipment.current_status_desc.toLowerCase().includes("rto")
                  ? "#E8F7EB"
                  : settings["--site-widget-primary-color-50"],
            }}
          >
            {shipment.current_status_desc.toLowerCase().includes("delivered") &&
            !shipment.current_status_desc.toLowerCase().includes("rto")
              ? "Delivered"
              : shipment.current_status_desc}
          </p>
        )}

        {shipment.items.map((item, i) => {
          const orderItem =
            orderDetails.order_items &&
            orderDetails.order_items.find(
              (oi) =>
                oi.sku === item.sku ||
                oi.variant_name === item.variant_name ||
                oi.order_item_id === item.order_item_id
            );
          const imageUrl =
            (orderItem && orderItem.image_url) || item.image_url || item.image;
          const title = orderItem
            ? orderItem.product_title
            : item.product_name ||
              item.product_title ||
              item.name ||
              item.title;
          return (
            <div
              className="flex items-center mt-3 p-2 rounded bg-[#F3F3F3]"
              key={i}
            >
              {imageUrl && (
                <img
                  className="rounded-md w-12 h-12 mr-4 text-xs overflow-hidden"
                  src={imageUrl}
                  alt={title}
                />
              )}
              <div className="text-xs">
                <p className="text-sm truncate w-60">{title}</p>
                <p className="mt-1 text-xs" style={{ color: "#858A93" }}>
                  <span
                    style={{ maxWidth: "120px" }}
                    className="inline-flex truncate"
                  >
                    {orderItem ? orderItem.variant_name : item.variant_name}
                  </span>{" "}
                  | Qty: {item.quantity}
                </p>
              </div>
            </div>
          );
        })}

        {(shipment.carrier || shipment.awbno) && (
          <div className="bg-[#F3F3F3] text-xs text-[#6F7580] px-2 py-1 rounded mt-4 inline-flex gap-4">
            {shipment.carrier && <span>by {shipment.carrier}</span>}
            {shipment.awbno && <span>AWB #{shipment.awbno}</span>}
          </div>
        )}

        <div className="mt-4 ml-1 border-l border-dashed border-[#C8CACE]">
          <TimelineItem
            status={true}
            item={{
              id: "5",
              label: "Order Placed",
              time: format(
                new Date(orderDetails.order_created_at),
                "dd MMM yyyy, hh:mm"
              ),
            }}
          />
          {shipment.shipment_travel_status &&
          shipment.shipment_travel_status !== null
            ? Object.values(shipment.shipment_travel_status).map((item) => {
                return (
                  <TimelineItem
                    status={item.completed}
                    item={item}
                    key={item.id}
                  />
                );
              })
            : deliveryStatuses.map((item) => {
                return (
                  <TimelineItem item={item} status={false} key={item.id} />
                );
              })}
        </div>

        {/* Bottom Modal */}

        {openScans && (
          <Fragment>
            <div className="overlay" onClick={() => setOpenScans(false)} />
            <div className="fixed bg-white h-full w-full top-40 z-50 -ml-10 overflow-auto animate-slide-in rounded">
              <p className="font-bold text-xs p-5">
                <span className="font-normal"> AWB </span> #{shipment.awbno}
              </p>
              <div className="border border-t-[#EAEAEB] border-b-[#EAEAEB] border-x-0">
                {shipment.scans.map((item, i) => {
                  return <Timeline item={item} key={item.id} status={true} />;
                })}
              </div>
            </div>
          </Fragment>
        )}
      </div>
    );
  };

  const [rating, setRating] = useState(0);
  const [writeReview, setWriteReview] = useState(false);
  const [reviewWritten, setReviewWritten] = useState(false);
  const [review, setReview] = useState("");

  const submitNPS = () => {
    setReviewWritten(true);
    npsSubmitApi(settings.merchant.id, orderDetails.order_id, rating, review)
      .then((resp) => {
        console.log(resp);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  return (
    <div>
      {/* Experience  */}
      {orderDetails.show_nps_details && (
        <div className="p-5 pb-0 text-sm">
          {reviewWritten ? (
            <p className="text-xs font-bold text-[#424A59]">
              Your feedback has been recorded. Thank you :)
            </p>
          ) : writeReview ? (
            <div>
              <div className="flex items-center">
                <div>
                  <p className="text-xs">Rating {rating}/10</p>
                  <p className="text-xs font-medium mt-1">
                    We'd love to know more from you
                  </p>
                </div>
                <button
                  className="ml-auto flex items-center text-white pl-3 pr-2 py-0.5 text-[10px] rounded bg-black"
                  onClick={() => submitNPS()}
                >
                  Submit <RiArrowRightSLine className="text-lg font-bold" />
                </button>
              </div>
              <textarea
                placeholder="Some feedback words here..."
                className="text-[#424A59] font-medium text-[11px] h-16 rounded w-full p-2 mt-4"
                onChange={(e) => setReview(e.target.value)}
              />
            </div>
          ) : (
            // ) : rating > 0 ? (
            //   <div>
            //     <p className="text-[#424A59] text-xs font-bold">
            //       Thank you for your feedback
            //     </p>
            //     <div className="flex justify-between text-xs mt-3">
            //       <p>Rating {rating}/10</p>
            //       <p
            //         className="flex items-center underline cursor-pointer"
            //         onClick={() => setWriteReview(true)}
            //       >
            //         Write a review <AiOutlineRight className="mt-0.5" />{" "}
            //       </p>
            //     </div>
            //   </div>
            <div>
              <p>Rate your experience with us</p>
              <p className="mt-2 text-xs text-red-500 font-bold">Worst :(</p>
              <div className="flex whitespace-nowrap justify-between w-full mt-1">
                {[...Array(10).keys()].map((experience) => {
                  return (
                    <p
                      className="rounded-half cursor-pointer bg-gray-300 w-6 h-6 text-xs text-center py-1 mr-2 text-black"
                      key={experience}
                      style={{
                        background:
                          experience === 0
                            ? "#DD435D66"
                            : experience === 1
                            ? "#DD435D66"
                            : experience === 2
                            ? "#FB8D0C66"
                            : experience === 3
                            ? "#FB8D0C66"
                            : experience === 4
                            ? "#EAC81766"
                            : experience === 5
                            ? "#EAC81766"
                            : experience === 6
                            ? "#ADE28366"
                            : experience === 7
                            ? "#ADE28366"
                            : experience === 8
                            ? "#2AD70E66"
                            : "#2AD70E66",
                      }}
                      onClick={() => {
                        setRating(experience + 1);
                        setWriteReview(true);
                      }}
                    >
                      {experience + 1}
                    </p>
                  );
                })}
              </div>
              <p className="text-right mt-1 text-xs text-green-500 font-bold">
                Best :)
              </p>
            </div>
          )}
        </div>
      )}
      {/* Order Details  */}
      <div className="p-5">
        {orderDetails.shipments.map((shipment, index) => {
          return (
            <OrderDetailsBox
              shipment={shipment}
              index={index + 1}
              key={index}
            />
          );
        })}
      </div>
    </div>
  );
}

export default OrderDetailsPage;
